import { render } from "./loginPage.vue?vue&type=template&id=16c4ffcd&scoped=true"
import script from "./loginPage.vue?vue&type=script&lang=js"
export * from "./loginPage.vue?vue&type=script&lang=js"

import "./loginPage.vue?vue&type=style&index=0&id=16c4ffcd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c4ffcd"]])

export default __exports__